export const createMarkup = (markup) => {
  return {__html: markup}
}

export const setParams = (url, paramsObject) => paramsObject.forEach(item => url.searchParams.set(item[0], item[1]))

export const isNumber = (n) => {
  return !isNaN(parseFloat(n)) && isFinite(n);
}
